import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getProfile } from './actions';

// Define the types for the state
interface MainState {
  myprofile: any; // Replace 'any' with the correct type for your profile data
  error: any; // Replace 'any' with the correct type for error (if you know the shape)
}

// Initial state with the type
const initialState: MainState = {
  myprofile: null,
  error: null,
};

export const mainReducer = createSlice({
  name: 'main',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProfile.fulfilled, (state, action: PayloadAction<any>) => {
        // action.payload should have the shape of the profile data
        state.myprofile = action.payload;
      })
      .addCase(getProfile.rejected, (state, action: PayloadAction<any>) => {
        // action.payload could represent the error, so adjust the type accordingly
        state.error = action.payload;
      });
  },
});

export default mainReducer.reducer;
